module.exports = (__webpack_require__("bricks/next-builder:JYlb"))("Bhyg");